module.exports = __webpack_public_path__ + "img/userB05.f1e073e6.jpg";